  import { createSlice } from '@reduxjs/toolkit';
  import { HttpMethod } from '../../../Asset/httpMethod';
  import { startLoader, stopLoader } from '../../Slices/Utility/loaderSlice';
  import { AlertPopup, errorPopup } from '../../../Asset/common';

  export const TableName = "PrpMast"

  export const fetchData = (isMessage) => async (dispatch) => {
    dispatch(startLoader())
    let ObjJsonDet = {
      jsonObj1: [{}],
      SPName: "API_PrpMastGet"
    }; 
    let res = await HttpMethod.post(`/SystemConfig/InsUpdDel/DynSpExAsyncDisp`, ObjJsonDet)
    if (res?.status === 200) {
      if(!(res.data.DynDisp) && isMessage){
        errorPopup(res.data)
        dispatch(getData({ DynDisp : []}));
      }
      else{
        dispatch(getData(await res.data));
      }

    }
    dispatch(stopLoader())
  };

  const constructDataJson = (data) => {
    let newData = {};
    for (let key in data) {
      newData[key.toLowerCase()] = data[key];
    }

    let dataJson = {};
    dataJson["jsonObj"] = [];
    dataJson["TableName"] = TableName;
    dataJson["jsonObj"].push(newData);
    return dataJson;
  };

  export const addData = (data) => async (dispatch) => {
    dispatch(startLoader())
    const dataJson = constructDataJson(data);
    const res = await HttpMethod.post('/SystemConfig/InsUpdDel/Add', dataJson);
    if (res?.status === 200) {
      AlertPopup.SuccessPopup(res.data);
      dispatch(fetchData())
    };
    dispatch(stopLoader());
  };

  export const updateData = (data) => async (dispatch) => {
    dispatch(startLoader())
    const dataJson = constructDataJson(data);
    const res = await HttpMethod.post('/SystemConfig/InsUpdDel/Update', dataJson);
    if (res?.status === 200) {
      AlertPopup.SuccessPopup(res.data);
      dispatch(fetchData())
    }
    dispatch(stopLoader())
  };

  export const deleteData = (data) => async (dispatch) => {
    dispatch(startLoader())
    const dataJson = constructDataJson(data);
    const res = await HttpMethod.post('/SystemConfig/InsUpdDel/Delete', dataJson);
    if (res?.status === 200) {
      AlertPopup.SuccessPopup(res.data);
      dispatch(fetchData())
    }
    dispatch(stopLoader())
  }

  export const PrpMastSlice = createSlice({
    name: 'PrpMast',
    initialState: {},
    loading: false,
    reducers: {
      getData: (state, action) => {
        return { ...action.payload };      
      }
    },
  });
  export const { getData } = PrpMastSlice.actions;
  export default PrpMastSlice.reducer;